/**
 * notify-url-param.js
 *
 * Reads ?notify={variantId} from the URL and auto-opens the matching
 * back-in-stock notify form — works on both the Notify Me list page and PDPs.
 *
 * Recommended Klaviyo email URL formats:
 *   List page: https://boroux.com/pages/notify-me?notify=41672017870926
 *   PDP:       https://boroux.com/products/slug?variant=41672017870926&notify=41672017870926
 *
 * On the PDP, include both ?variant= and ?notify= so the page renders the
 * correct variant server-side, then this script clicks the Klaviyo BIS button.
 */

const PARAM = 'notify';
const KLAVIYO_BTN_SELECTOR = '#klaviyo-bis-button-container button';
const WAIT_TIMEOUT_MS = 8000;
const POLL_INTERVAL_MS = 100;

function getNotifyVariantId() {
  return new URLSearchParams(window.location.search).get(PARAM);
}

function cleanUrl() {
  const url = new URL(window.location.href);
  url.searchParams.delete(PARAM);
  window.history.replaceState({}, '', url.toString());
}

/**
 * Notify Me list page — restock-notify-list section.
 * Finds the row by data-restock-notify-toggle, scrolls to it, opens the form.
 */
function handleRestockListPage(variantId) {
  const btn = document.querySelector(`[data-restock-notify-toggle="${variantId}"]`);
  if (!btn) return false;

  const formEl = document.getElementById(`restock-form-${variantId}`);
  if (!formEl) return false;

  const row = btn.closest('.restock-row');
  row?.scrollIntoView({ behavior: 'smooth', block: 'center' });

  formEl.removeAttribute('hidden');
  row?.classList.add('restock-row--highlighted');

  return true;
}

/**
 * PDP — clicks the Klaviyo BIS button.
 * Klaviyo injects #klaviyo-bis-button-container asynchronously, so we poll
 * for it until it appears or we time out.
 */
function handlePdpPage() {
  // Already present — click immediately
  const existing = document.querySelector(KLAVIYO_BTN_SELECTOR);
  if (existing) {
    clickBisButton(existing);
    return true;
  }

  // Not yet present — wait for Klaviyo to inject it
  const start = Date.now();
  const interval = setInterval(() => {
    const btn = document.querySelector(KLAVIYO_BTN_SELECTOR);
    if (btn) {
      clearInterval(interval);
      clickBisButton(btn);
      return;
    }
    if (Date.now() - start > WAIT_TIMEOUT_MS) {
      clearInterval(interval);
    }
  }, POLL_INTERVAL_MS);

  return true;
}

function clickBisButton(btn) {
  btn.closest('#klaviyo-bis-button-container')
    ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  btn.click();
}

function init() {
  const variantId = getNotifyVariantId();
  if (!variantId) return;

  cleanUrl();

  if (handleRestockListPage(variantId)) return;
  handlePdpPage();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
